import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AppBar from 'material-ui/AppBar';

export class HeaderBar extends Component {
  render() {
    return (
      <AppBar
        className="hideOnPrint"
        title={this.props.title}
        onLeftIconButtonTouchTap={this.props.onLeftIconClick}
        iconElementRight={this.props.rightElement}
      />
    );
  }
}

HeaderBar.propTypes = {
  title: PropTypes.string.isRequired,
  onLeftIconClick: PropTypes.func,
  rightElement: PropTypes.element,
}

export default HeaderBar;


// WEBPACK FOOTER //
// ./src/components/HeaderBar/index.js